<!-- 官网首页：切图 assets/imgs 宽度 100% 随视口缩放，PC/手机全宽 -->
<template>
  <div class="home">
    <header class="top">
      <div class="top-inner">
        <img :src="assets.headerLogo" alt="LIVEO" class="header-logo" />
        <div class="top-spacer" />
        <nav class="top-nav">
          <a href="/user-agreement?lang=en">User Agreement</a>
          <a href="/privacy-policy?lang=en">Privacy Policy</a>
        </nav>
      </div>
    </header>

    <div class="content-shell">
      <main class="main">
        <section class="section section-hero">
          <img :src="assets.section1" alt="" class="section-img" />
          <a
            class="download-btn"
            :href="downloadUrl"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download App"
          >
            <img :src="assets.downloadBtn" alt="Download App" />
          </a>
        </section>
        <section v-for="(src, index) in sectionRest" :key="index" class="section">
          <img :src="src" alt="" class="section-img" />
        </section>
      </main>

      <footer class="footer">
        <div class="footer-wrap">
          <img :src="assets.footerStrip" alt="" class="footer-strip" />
          <div class="contact">
            <h3 class="contact-title">Contact Us</h3>
            <p class="contact-line">Email：{{ contactEmail }}</p>
            <p class="contact-line">Phone：{{ contactPhone }}</p>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

/** 联系我们（写死，不读配置） */
const CONTACT_EMAIL = 'dbandrewxu@gmail.com'
const CONTACT_PHONE = '+852 51427983'
/** 下载跳转（默认占位，上线前替换为 App Store / APK） */
const DOWNLOAD_URL = 'https://www.pgyer.com/liveo-android'

export default {
  name: 'LIVEO',
  setup () {
    const assets = {
      headerLogo: require('../assets/imgs/logo.png'),
      section1: require('../assets/imgs/1.png'),
      section2: require('../assets/imgs/2.png'),
      section3: require('../assets/imgs/3.png'),
      section4: require('../assets/imgs/4.png'),
      downloadBtn: require('../assets/imgs/download.png'),
      footerStrip: require('../assets/imgs/footer.png')
    }

    const sectionRest = ref([
      assets.section2,
      assets.section3,
      assets.section4
    ])

    return {
      assets,
      sectionRest,
      downloadUrl: DOWNLOAD_URL,
      contactEmail: CONTACT_EMAIL,
      contactPhone: CONTACT_PHONE
    }
  }
}
</script>

<style scoped>
.home {
  width: 100%;
  min-height: 100vh;
  background: #0a0612;
  color: #e8e0f0;
  overflow-x: hidden;
}

.top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(10, 6, 18, 0.92);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.top-inner {
  display: flex;
  align-items: center;
  width: 100%;
  height: 52px;
  margin: 0 auto;
  padding: 0 clamp(16px, 4vw, 48px);
  box-sizing: border-box;
}

.header-logo {
  display: block;
  height: 32px;
  width: auto;
  max-width: min(220px, 55vw);
  object-fit: contain;
  object-position: left center;
}

.top-spacer {
  flex: 1;
}

.top-nav {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.top-nav a {
  color: #f0ecf5;
  font-size: 13px;
  text-decoration: none;
  white-space: nowrap;
}

.top-nav a:hover {
  color: #c4a8ff;
}

.content-shell {
  width: 100%;
  max-width: none;
  margin: 0;
  padding-top: 52px;
  box-sizing: border-box;
}

.main {
  line-height: 0;
  font-size: 0;
}

.section {
  position: relative;
  width: 100%;
  margin: 0;
  padding: 0;
}

.section + .section {
  margin-top: -1px;
}

.section-img {
  display: block;
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
  vertical-align: top;
}

/*
 * 横版首屏 1.png（3840×1916）：按钮在左侧英文副标题下方、大拇指左侧
 * 百分比相对 section 宽高，随切图等比缩放
 */
.section-hero .download-btn {
  position: absolute;
  left: 18.8%;
  top: 53%;
  width: 17.5%;
  max-width: 200px;
  line-height: normal;
  font-size: 14px;
}

.section-hero .download-btn img {
  display: block;
  width: 100%;
  height: auto;
  filter: drop-shadow(0 4px 16px rgba(120, 60, 255, 0.35));
  transition: transform 0.2s ease;
}

.section-hero .download-btn:hover img {
  transform: scale(1.03);
}

.footer {
  line-height: normal;
  font-size: 14px;
  margin-top: -1px;
}

.footer-wrap {
  position: relative;
  width: 100%;
}

.footer-strip {
  display: block;
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
  vertical-align: top;
}

/* 联系信息叠在 footer.png 视觉中心 */
.contact {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
  text-align: center;
}

.contact-title {
  margin: 0 0 16px;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}

.contact-line {
  margin: 12px 0 0;
  font-size: 14px;
  color: #fff;
}

@media (min-width: 768px) {
  .top-inner {
    height: 60px;
  }

  .content-shell {
    padding-top: 60px;
  }

  .header-logo {
    height: 36px;
  }

  .top-nav a {
    font-size: 14px;
  }

  .top-nav {
    gap: 20px;
  }
}

@media (max-width: 480px) {
  .section-hero .download-btn {
    left: 5.5%;
    top: 47%;
    width: 19%;
    max-width: none;
  }

  .contact-title {
    font-size: 16px;
  }

  .contact-line {
    font-size: 12px;
  }

  .top-nav a {
    font-size: 12px;
  }
}
</style>
